import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@/features/emr';

export const Route = createFileRoute('/_authenticated/documents/list')({
  component: DocumentsPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { href: '/documents', title: 'Inbox' },
      { href: '/documents/list', title: 'Document inbox list' },
    ],
  }),
});
